import { useEffect } from "react";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";
import { RootState } from "../../Redux/store";
import {
  getSessionToken,
  isCreatorRole,
} from "../../Config/common.config";

const socketURL =
  process.env.REACT_APP_SOCKET_ENDPOINT ||
  process.env.REACT_SOCKET_ENDPOINT ||
  "http://localhost:3000";

const CreatorPresenceConnection = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const user = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (!isAuthenticated || !user.id || !isCreatorRole(user.role)) return;

    const token = getSessionToken();
    if (!token) return;

    const socket = io(socketURL, {
      auth: { token },
      reconnection: true,
    });

    return () => {
      socket.disconnect();
    };
  }, [isAuthenticated, user.id, user.role]);

  return null;
};

export default CreatorPresenceConnection;
